export const campaignTranslations = {
    en: {
        pageTitle: "Camp List",
        createCamp: "Create Camp",
        campCode: "Camp Code",
        campName: "Camp Name",
        address: "Address",
        district: "District",
        taluka: "Taluka",
        village: "Village",
        campStatus: "Camp Status",
        campType: "Camp Type",
        startDate: "Start Date",
        endDate: "End Date",
        createdBy: "Created By",
        createdAt: "Created At",
        searchPlaceholder: "Search name, taluka, district...",

        // Status filters
        totalCamps: "Total Camps",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        completed: "Complete",
        ongoing: "Ongoing",
        overdue: "Overdue",
        upcoming: "Upcoming",
    },
    mr: {
        pageTitle: "शिबिर यादी",
        createCamp: "शिबिर तयार करा",
        campCode: "शिबिर कोड",
        campName: "शिबिराचे नाव",
        address: "पत्ता",
        district: "जिल्हा",
        taluka: "तालुका",
        village: "गाव",
        campStatus: "शिबिराची स्थिती",
        campType: "शिबिराचा प्रकार",
        startDate: "प्रारंभ तारीख",
        endDate: "समाप्ती तारीख",
        createdBy: "निर्मिती केली",
        createdAt: "निर्मिती तारीख",
        searchPlaceholder: "नाव, तालुका, जिल्हा शोधा...",

        totalCamps: "एकूण शिबिरे",
        pending: "प्रलंबित",
        approved: "मंजूर",
        rejected: "नाकारले",
        completed: "पूर्ण झाले",
        ongoing: "सुरू आहे",
        overdue: "मुदत संपली",
        upcoming: "आगामी",
    }
};
